
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import divScroll from "@/components/div-scroll/div-scroll.vue";
import { objAny } from "@/common/common-interface";
import { State } from "vuex-class";
@Component({
  components: {
    "pi-div-scroll": divScroll
  }
})
export default class PiMenu extends Vue {
  @Prop({ default: "" }) private menuId!: string;
  @Prop({ default: true }) private isCollapse!: boolean;
  @State("sys") sys!: objAny;
  @Watch("menuId")
  getVisible() {
    this.openNames = [this.getTowMenu(this.menuId)];
  }
  private theme2 = "light";
  private openNames: string[] = [];
  private menuShow = false;
  public zoomClick(): void {
    this.$emit("collapse");
  }

  public getTowMenu(key: string): string {
    const arr = key.split("-");
    return arr[0] + "-" + arr[1];
  }

  public smallMenuClick(item: objAny): void {
    this.$router.push(item.url);
  }
}
